import { useTranslation } from 'react-i18next'
import styles from './MobileWarning.module.scss'
import Button from '../Button/Button'

const MobileWarning = ({ handleClick }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.wrapper}>
      <p>{t('common:mobilewarning.text')}</p>
      <Button
        onClick={handleClick}
        variant='secondary'
        size='small'
        style={{ margin: '1rem auto 0 auto' }}
      >
        {t('common:confirm')}
      </Button>
    </div>
  )
}

export default MobileWarning
